import React, { ElementType, forwardRef, ReactNode } from 'react';
import { chakra, TextProps, useStyleConfig } from '@chakra-ui/react';

type Sizes = `xxs` | `xs` | `sm` | `md` | `lg` | `xl`;
type Variants = `preHeader` | `preHeaderBorder` | `preHeaderBorderHeavierGray`;

interface Props extends Omit<TextProps, `fontSize`> {
  children?: ReactNode;
  as?: ElementType;
  variant?: Variants;
  size?: Sizes;
}

export const Text = forwardRef<HTMLDivElement, Props>(
  ({ children, as, variant, size, ...props }, ref): JSX.Element => {
    const styles = useStyleConfig(`Text`, { size, variant });

    return (
      <chakra.p as={as || `p`} ref={ref} __css={styles} {...props}>
        {children}
      </chakra.p>
    );
  }
);
export type { Props as TextProps };
